import React from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { areEqual } from 'react-window';

interface WindowItemProps {
  data: ((style: CSSProperties) => ReactNode)[];
  index: number;
  style: CSSProperties;
}

const WindowItem = ({ data, index, style }: WindowItemProps) =>
  data[index]?.(style);

export default React.memo(WindowItem, areEqual);
